import React from "react";
import swimmingPool from "../../../Assets/icons/swimming-pool.png";
import medicalService from "../../../Assets/icons/hospital.png";
import restaurents from "../../../Assets/icons/restaurant.png";
import wifi from "../../../Assets/icons/wifi.png";

import carparking from "../../../Assets/icons/car-parking.png";
import kids from "../../../Assets/icons/slider.png";
import playground from "../../../Assets/icons/playground.png";
import { Link } from "react-router-dom";
const ResortSurprize = () => {
  return (
    <div className="max-w-screen-xl mx-auto  py-20 px-5 xl:px-10">
      <div className="nahid-title-designer   pt-10 flex justify-center md:justify-start">
        <h1
          className="mb-20 md:text-[40px] lg:text-[48px] text-[25px] font-bold"
          data-aos="zoom-in-up"
        >
          Resort Surprises
        </h1>
      </div>

      <div className="  grid grid-cols-1 gap-10 px-10  sm:px-20 ">
        <div className="grid md:grid-cols-2 grid-cols-1 gap-10">
          <Link to="/Facilities">
            <div
              data-aos="zoom-in"
              className="flex justify-center md:justify-start"
            >
              <div className="w-full p-6 bg-white border border-gray-200 rounded-lg shadow-md">
                <div className="flex md:justify-between flex-col md:flex-row md:gap-10 items-center">
                  <h5 className="mb-2 font-semibold tracking-tight text-gray-900 dark:text-white text-center md:text-start">
                    <small className="text-[#d23a10]">Emergency </small> <br />{" "}
                    <span className="text-xl">Medical Service</span>
                  </h5>
                  <img src={medicalService} alt="" className="w-[50px]" />
                </div>
              </div>
            </div>
          </Link>
          <Link to="/Swimming_Pool">
            <div
              data-aos="zoom-in"
              className="flex justify-center md:justify-start"
            >
              <div className="w-full p-6 bg-white border border-gray-200 rounded-lg shadow-md">
                <div className="flex md:justify-between flex-col md:flex-row items-center md:gap-10">
                  <h5 className="mb-2  font-semibold tracking-tight text-gray-900 dark:text-white text-center md:text-start">
                    <small className="text-[#d23a10]">Infinity</small>
                    <p className="text-xl">Swimming Pool</p>
                  </h5>
                  <img src={swimmingPool} alt="" className="w-[50px]" />
                </div>
              </div>
            </div>
          </Link>
          <Link to="/Restaurant">
            <div
              data-aos="zoom-in"
              className="flex justify-center md:justify-start"
            >
              <div className="w-full p-6 bg-white border border-gray-200 rounded-lg shadow-md">
                <div className="flex md:justify-between flex-col md:flex-row items-center md:gap-10">
                  <h5 className="mb-2  font-semibold tracking-tight text-gray-900 dark:text-white">
                    <small className="text-[#d23a10]">Large</small>
                    <p className="text-xl">Restaurant</p>
                  </h5>
                  <img src={restaurents} alt="" className="w-[50px]" />
                </div>
              </div>
            </div>
          </Link>
          <Link to="/Facilities">
            <div
              data-aos="zoom-in"
              className="flex justify-center md:justify-start"
            >
              <div className="w-full p-6 bg-white border border-gray-200 rounded-lg shadow-md ">
                <div className="flex md:justify-between flex-col md:flex-row items-center md:gap-10">
                  <h5 className="mb-2 font-semibold tracking-tight text-gray-900 dark:text-white">
                    <small className="text-[#d23a10]">
                      Centrally uninterrupted
                    </small>
                    <br /> <span className="text-xl">Wi-Fi Connection</span>
                  </h5>
                  <img src={wifi} alt="" className="w-[50px]" />
                </div>
              </div>
            </div>
          </Link>

          <Link to="/Facilities">
            <div
              data-aos="zoom-in"
              className="flex justify-center md:justify-start"
            >
              <div className="w-full p-6 bg-white border border-gray-200 rounded-lg shadow-md ">
                <div className="flex md:justify-between flex-col md:flex-row items-center md:gap-10">
                  <h5 className="mb-2 font-semibold tracking-tight text-gray-900 dark:text-white">
                    <small className="text-[#d23a10] text-center md:text-start">
                      Large
                    </small>{" "}
                    <p className="text-xl"> Car Parking </p>
                  </h5>
                  <img src={carparking} alt="" className="w-[50px]" />
                </div>
              </div>
            </div>
          </Link>
          <Link to="/play-Ground">
            <div
              data-aos="zoom-in"
              className="flex justify-center md:justify-start"
            >
              <div className="w-full p-6 bg-white border border-gray-200 rounded-lg shadow-md ">
                <div className="flex md:justify-between flex-col md:flex-row items-center md:gap-10">
                  <h5 className="mb-2 font-semibold tracking-tight text-gray-900 dark:text-white">
                    <small className="text-[#d23a10]">Wide</small> <br />{" "}
                    <span className="text-xl">Play Ground</span>
                  </h5>
                  <img src={playground} alt="" className="w-[50px]" />
                </div>
              </div>
            </div>
          </Link>
          <Link to="/Kids-zone">
            <div
              data-aos="zoom-in"
              className="flex justify-center md:justify-start"
            >
              <div className="w-full p-6 bg-white border border-gray-200 rounded-lg shadow-md ">
                <div className="flex md:justify-between flex-col md:flex-row items-center md:gap-10">
                  <h5 className="mb-2  font-semibold tracking-tight text-gray-900 dark:text-white">
                    <small className="text-[#d23a10]">Outdoor</small>

                    <p className="text-xl"> Kids Zone</p>
                  </h5>
                  <img src={kids} alt="" className="w-[50px]" />
                </div>
              </div>
            </div>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default ResortSurprize;
